import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { setAuthenticatedCallback, CheckLogin } from './api';
import AccountAccess from './components/AccountAccess';
import Portal from './components/Portal';
import CheckInForm from './components/CheckIn';
import KioskApp from './components/Kiosk';
import { Provider, ErrorBoundary } from '@rollbar/react';

const rollbarConfig = {
  accessToken: '5db6e4864fd14d588bf9a31a39f1cefa',
  environment: 'prod',
  captureUncaught: true,
  captureUnhandledRejections: true,
};

// Thin wrapper so useParams works inside the Router
const CheckInRoute = () => {
  const { token } = useParams();
  return <CheckInForm token={token} />;
};

const KioskRoute = () => {
  const { deviceToken } = useParams();
  // Store token in sessionStorage then redirect to /kiosk so the
  // plaintext token is not left in browser history or the address bar
  useEffect(() => {
    if (deviceToken) {
      sessionStorage.setItem('kioskToken', deviceToken);
      window.history.replaceState(null, '', '/kiosk');
    }
  }, [deviceToken]);
  return <KioskApp />;
};

const App = () => {
  const [isAuthenticated, setAuthenticated] = useState(CheckLogin());

  useEffect(() => {
    setAuthenticatedCallback(setAuthenticated);
  }, []);

  const routes = (
    <Router>
      <Routes>
        {/* Public unauthenticated check-in — always accessible */}
        <Route path="/checkin/:token" element={<CheckInRoute />} />
        {/* Kiosk mode — device token in URL on first load, stored in sessionStorage, then redirected to /kiosk */}
        <Route path="/kiosk/:deviceToken" element={<KioskRoute />} />
        <Route path="/kiosk" element={<KioskApp />} />
        {/* Staff portal — auth gated */}
        {isAuthenticated ? (
          <Route path="*" element={<Portal />} />
        ) : (
          <Route path="*" element={<AccountAccess setAuthenticated={setAuthenticated} />} />
        )}
      </Routes>
    </Router>
  );

  if (process.env.REACT_APP_ENV === 'production')
    return (
      <Provider config={rollbarConfig}>
        <ErrorBoundary>{routes}</ErrorBoundary>
      </Provider>
    );

  return routes;
};

export default App;
